import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const SidebarHide16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M14.5303 3.03033L13.4697 1.96967L9.93933 5.5L13.4697 9.03033L14.5303 7.96967L12.0607 5.5L14.5303 3.03033Z'
      fill='currentColor'
    />
    <path d='M8 4.25H1V2.75H8V4.25Z' fill='currentColor' />
    <path d='M1 8.75H8V7.25H1V8.75Z' fill='currentColor' />
    <path d='M1 11.75V13.25H15V11.75H1Z' fill='currentColor' />
  </Svg>
);

SidebarHide16.displayName = 'SidebarHide16';
export default SidebarHide16;
